export const environment = {
    production: true,
    authApiUrl: 'https://auth.api.ums.1minutepourmoncoeur.fr',
    pmpApiUrl: 'https://pmp.api.ums.1minutepourmoncoeur.fr/',
    pmpSockets: 'wss://pmp.api.ums.1minutepourmoncoeur.fr/',
    apiUrl: 'https://api.ums.1minutepourmoncoeur.fr/1.0',
    authfrontURL: 'https://auth.ums.1minutepourmoncoeur.fr',
    psp: 'https://ums.1minutepourmoncoeur.fr',
    psa: 'https://alerts.ums.1minutepourmoncoeur.fr',
    newcardUrl: 'https://(alerts.)?ums.1minutepourmoncoeur.fr.*',
    cookieDomain: '.1minutepourmoncoeur.fr',
    insiConsult: 'https://ins.ums.1minutepourmoncoeur.fr',
    helpPage: 'https://newcard.io/espace-daide/',
    jfse: {
        urlkitWindows: 'https://updates.jfse.fr/files/lecteur/3.37/setup_lsv_win_3.37-default.exe',
        urlKitMac: 'https://updates.jfse.fr/files/lecteur/3.37/setup_lsv_mac_3.37-default.pkg.zip',
        hostToConfig: 'fse-lecteur-preprod.jfse.fr',
        portToConfig: 443,
        daemonConfigPanelUrl: 'http://127.0.0.1:8888',
        apcv: false,
        vital: false,
        scor: false,
        enableSecured: false,
        enableUnsync: false,
        enableDegraded: false,
    },
};
